export default theme => ({
  alignedLink: {
    display: "inline-block",
    marginTop: 50,
    marginRight: 50,
  },
  alignedLink_text: {
    marginLeft: 15,
    display: "inline-block",
  },
  alignedLink_icon: {
    display: "inline-block",
    verticalAlign: "middle",
  },
  alignedLink__externalLink: {
    cursor: "pointer",
  },
  alignedLink__externalLink__text: {
    display: "inline-block",
    marginLeft: 10,
    verticalAlign: "super",
  },
  table: {
    marginTop: 20,
  },
  warning: {
    marginTop: 20,
  },
  button: {
    color: "black",
    borderColor: theme.palette.white.main,
    background: theme.palette.white.main,
    borderStyle: "hidden",
  },
});
